import React from "react";

const ImportInstruction = () => {
  return (
    <div className="p-[15px] bg-white m-[20px] mr-0 ml-[50px] rounded-[15px]">
      <p className="text-[15px] text-gray-500">
        Importing a spreadsheet file is the fastest way to add a large number of
        products to your store at once. You can upload a file in Excel format
        (XLSX/XLS) or CSV format.
        <br />
        <br />
        It's important to have mandatory fields completed and all details
        correctly inputted into your file before uploading.
      </p>
    </div>
  );
};

export default ImportInstruction;
